import React from "react";
import Sheets from "../../../../containers/Home/Sheets";
import Video from "../../../../containers/Home/Pages/Video";
import backgroundMobile2 from "../../../../assets/icons/backgroundMobile2.svg";
import backgroundMobile2Bis from "../../../../assets/icons/backgroundMobile2Bis.svg";
import backgroundMobile3 from "../../../../assets/icons/backgroundMobile3.svg";
import backgroundMobile3Bis from "../../../../assets/icons/backgroundMobile3Bis.svg";
import imgPepiteInfos from "../../../../assets/img/pepiteInfos.svg";
import PropTypes from "prop-types";
import LeBlog from "../../../../containers/Home/Pages/LeBlog";
import useWindowDimensions from "../../../../hook/useWindowDimension";

const PepiteInfos = ({
                         page,
                         handleOpenNavItem,
                         navItem,
                         dataUser
                     }) => {
    const {width} = useWindowDimensions();
    return (
        <div>
            <div className={"pepiteInfos"}>
                {navItem == "pepiteInfos" &&
                    <div className={"pepiteInfos-header"}>
                        <img src={imgPepiteInfos}/>
                        <h2 className={"titleMobile1"}>
                            Pépite<span className={"titleMobile2 nauticus"}> d&apos;infos</span>
                        </h2>
                    </div>
                }
                <div className={"pepiteInfos-container"}>
                    <img className={"background-2"} src={width > 599 ? backgroundMobile2 : backgroundMobile2Bis}/>
                    <img className={"background-3"} src={width > 599 ? backgroundMobile3 : backgroundMobile3Bis}/>

                    <div className={"mobile-list-container blog-accueil list-cases"}
                         id={"blog-accueil"}>
                        <LeBlog
                            handleOpenNavItem={handleOpenNavItem}
                            navItem={navItem}
                            dataUser={dataUser}
                        />
                    </div>
                    <div className={"mobile-list-container fiches-pratiques-accueil list-cases"}>
                        <Sheets
                            handleOpenNavItem={handleOpenNavItem}
                            dataUser={dataUser}
                        />
                    </div>

                    <div className={"mobile-list-container les-tutos-accueil list-cases"}>
                        <Video
                            handleOpenNavItem={handleOpenNavItem}
                            dataUser={dataUser}
                        />
                    </div>
                    {/*<div className={"mobile-list-container les-newsletters-accueil list-cases"}>*/}
                    {/*    <Newsletters*/}
                    {/*        handleOpenNavItem={handleOpenNavItem}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    {/*<div className={"mobile-list-container les-temoignages-accueil list-cases"}>*/}
                    {/*    <Temoignages*/}
                    {/*        handleOpenNavItem={handleOpenNavItem}*/}
                    {/*    />*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    );
};

PepiteInfos.propTypes = {
    page: PropTypes.string,
    handleOpenNavItem: PropTypes.func,
    navItem: PropTypes.string,
    dataUser: PropTypes.object
};

export default PepiteInfos;
